import UrlDataFile from 'src/configs/urls.json';

// type ExecutableType =
//   | 'development-env'
//   | 'production-env'
//   | 'operational-env'
//   | 'local-online'
//   | 'local-offline'
//   | 'customized';

type UrlConfigType = {
  socketURL: string;
  webServerBaseURL: string;
  surferURL: string;
  cppMessengerURL: string;
  hymotsGURL: string;
  etecubeURL: string;
  excelImportUrl: string;

  loggerServerBaseURL: string;
  fileServerBaseURL: string;
  layersServerBaseURL: string;
  storageServerURL: string;
  systemLoginURL: string;
  dfmURL: string;
  systemLoginWebServerBaseURL: string;
  formserverURL: string;
};

// bunu şu sebepten yapıyorum
// build kulanılırken dışarıdan verilen urls.json file ı okunsun diye yoksa build alınırken ki urls.json dosyası okunur.
const isBuildRun = window.EXECUTABLE_TYPE && window.EXECUTABLE_TYPE !== '{{EXECUTABLE_TYPE}}';

// const selectedExecutableType: ExecutableType = 'customized'; // localinde çalışıyorsan url leri burdan değiştireceksin.

const urlConfiguration = (): UrlConfigType => {
  // eğer build aşamasındaysa exe ye verilen url ler okunacak
  if (isBuildRun) {
    return {
      socketURL: window.SOCKET_URL,
      webServerBaseURL: window.WEB_SERVER_URL,
      excelImportUrl: window.EXCEL_IMPORT_GENERATOR_URL,
      hymotsGURL: window.HYMOTS_G_URL,
      etecubeURL: window.ETECUBE_URL,

      cppMessengerURL: window.CPP_MESSENGER_URL,
      surferURL: window.SURFER_URL,
      storageServerURL: window.STORAGE_SERVER_URL,
      loggerServerBaseURL: window.LOGGER_SERVER_URL,
      fileServerBaseURL: window.FILE_SERVER_URL,
      layersServerBaseURL: window.LAYERS_SERVER_URL,
      systemLoginURL: window.SYSTEM_LOGIN_URL,
      systemLoginWebServerBaseURL: window.SYSTEM_LOGIN_WEB_SERVER_URL,
      dfmURL: window.DFM_URL,
      formserverURL: '',
    };
  }
  return UrlDataFile as UrlConfigType;
};
const urlsConfig = {
  ...urlConfiguration(),

  user: {
    register: '/users',
    multipleAccountRegister: '/users/multipleRegister',
    verifyRegisterToken: '/users/verifyRegisterToken',
    getRefreshToken: 'users/getRefreshToken',
    login: '/users/login',
    logout: '/users/logout',
    getInformation: '/users/@me',
    lookup: '/users',
    approveRegister: '/register/approve',
    declineRegister: '/register/decline',
    updateProfile: '/users/profile',
    updateUser: '/users',
    updatePassword: '/users/updatePassword',
    userEmail: '/users/email',
    deleteUser: '/users',
    getUsers: '/users',
    resetPassword: '/users/resetPassword',
    updateLanguage: '/users/preferred-language',
    twoFactorAuth: '/users/two-factor-auth',
    googleAuthLogin: '/users/google-auth-login',
    roles: '/roles',
    googleAuthGetQr: 'users/qrCode',
    lostQrCodeMail: 'users/lostQrCodeMail',
    verifyResetToken: '/users/verifyResetPassword',
    verifyMailAuthenticationToken: '/users/verifyMailAuthentication',
    authenticateUser: '/users/mail-auth-login',
    forgotPassword: '/users/resetPasswordMail',
    userAllRegisterInvitation: '/register-invitations',
    sendRegisterInvitation: '/register-invitations',
    updateIsFirstAdmin: '/users/firstAdmin',
    updateCustomerTwoFA: '/users/AuthTwoFactor',
    customers: '/users/customers',
    updatePortalUser: '/users/updateUserPortal',
  },
  nSearchLogger: {
    nSearch: '/nsearch',
  },
  generalReports: {
    create: '/general-reports',
    delete: '/general-reports',
    lookup: '/general-reports',
    download: '/general-reports/download',
    view: '/general-reports/view',
    downloadFiles: '/general-reports/downloadFiles',
    refresh: '/general-reports/refresh',
  },
  systemLogin: {
    verifyLicence: '/users/verifyLicence',
  },
  surfer: {
    dashboard: '/dashboard',
    mediaInsights: '/mediaInsights',
    relevantNews: '/relevantNews',
    interestLocation: '/geotemporal',
    nsearch: '/chain/nsearch',
    interest: 'chain/interest',
    blockOriginal: '/block',
    individualNetwork: '/network/individual',
    socialNetwork: '/network/social',
    network: '/network',
    blockStatistic: {
      lookup: '/block-statistic',
      create: '/block-statistic',
      update: '/block-statistic',
      delete: '/block-statistic',
      startPrediction: '/block-statistic/startPrediction',
    },
    editBlock: '/block-editors',
    estimation: '/statistic/estimateNotification',
    dataCount: '/statistic/dataCount',
    bulkDataCount: '/statistic/dataCount2',
    timeline: '/timeline',
  },
  dfm: {
    decryptDataSrc: '/decrypt',
  },
  layersServer: 'layers_server',

  faq: {
    lookup: '/faq',
    create: '/faq',
    update: '/faq',
    delete: '/faq',
  },

  interest: {
    base: '/interests',
    bulkLookup: '/interests',
    learner: '/learner/start',
    identified: {
      topic: {
        lookup: '/interests/identified/topics',
        create: '/interests/identified/topics',
        update: '/interests/identified/topics',
        delete: '/interests/identified/topics',
      },
      location: {
        lookup: '/interests/identified/location',
        create: '/interests/identified/location',
        update: '/interests/identified/location',
        delete: '/interests/identified/location',
        images: '/interests/identified/location/images',
        checkPicture: '/interests/identified/location/checkPicture',
        import: '/imports/location',
      },
      sensor: {
        lookup: '/interests/identified/sensors',
        create: '/interests/identified/sensors',
        update: '/interests/identified/sensors',
        delete: '/interests/identified/sensors',
        import: '/imports/sensor',
      },

      enterprise: {
        lookup: '/interests/identified/enterprise',
        relations: '/interests/identified/enterprise/relations',
        update: '/interests/identified/enterprise',
        delete: '/interests/identified/enterprise',
        enterpriseIsExists: 'interests/identified/enterprise/isExists',
        generateReport: '/interests/identified/enterprise/report',
        // create: "/interests/identified/enterprise",
        import: '/imports/enterprise',
      },

      vehicle: {
        lookup: '/interests/identified/vehicles',
        create: '/interests/identified/vehicles',
        update: '/interests/identified/vehicles',
        delete: '/interests/identified/vehicles',
        import: '/imports/vehicle',
      },
      person: {
        lookup: '/interests/identified/people',
        create: '/interests/identified/people',
        update: '/interests/identified/people',
        delete: '/interests/identified/people',
        checkPicture: '/interests/identified/people/checkPicture',
        deletePhotosFromCache: '/interests/identified/people/deletePhotosFromCache',
        cleanCache: '/interests/identified/people/cleanCache',
        genders: '/genders',
        import: '/imports/person',
        profilePicture: '/interests/identified/people/profilePicture',
      },
      relation: {
        getRelationsOfCompany: '/interests/identified/relation/company/relations',
        update: '/interests/identified/relation',
        create: '/interests/identified/relation',
        lookup: '/interests/identified/relation',
        delete: '/interests/identified/relation',
        updateMonitorSupplier: '/interests/identified/relation/updateMonitoredSupplier',
        addSupplier: '/interests/identified/relation/addSupplier',
        bulkImport: '/interests/identified/relation/bulk',
        types: '/interactionTypes',
        deleleteSupplier: '/interests/identified/relation/supplier',
        import: '/imports/relation',
      },
      transaction: {
        lookup: '/interests/identified/transaction',
        create: '/interests/identified/transaction',
        update: '/interests/identified/transaction',
        delete: '/interests/identified/transaction',
      },
    },
    recognized: {
      industry: '/interests/recognized/industries',
      location: '/interests/recognized/location',
      funtionalArea: '/interests/recognized/functionalArea',
      vehicle: '/interests/recognized/vehicle',
      person: '/interests/recognized/person',
      incident: {
        lookup: '/interests/recognized/incident',
        update: '/interests/recognized/incident',
      },
      communication: '/interests/recognized/communication',
      enterprise: '/interests/recognized/enterprise',
      object: '/interests/recognized/object',
      unit: {
        lookup: '/interests/recognized/agent/categories',
        types: '/unit/types',
        categories: '/interests/recognized/unitCategories',
        models: '/interests/recognized/agent/models',
      },
      transaction: {
        lookup: '/interests/recognized/transaction',
      },
    },
  },
  patterns: {
    lookup: '/pattern-based-interest-metrics',
  },
  customer: {
    register: '/customer',
    customerRegister: '/customers/register',
    lookup: '/customers',
    update: '/customers',
    delete: '/customers',
    customerMultipleAccountRegister: '/customer/multipleAccountRegister',
    registerInvitation: '/customer-register/sendRegisterInvitation',
    verifyRegisterToken: '/customer-register/verifyRegisterToken',
    customersOfUser: '/customer/customers-of-user',
    customerAccountTypes: '/customerAccountTypes',
    companyOfCustomers: {
      lookup: '/company-of-customers',
    },
    updateAccountType: '/customers/accountType',
  },
  webBackendSurfer: {
    surfer: '/surfer',
  },
  webBackendMessenger: {
    postSenderEmailSettings: '/messenger-module/senderEmailSettings',
    getSenderEmailSettings: '/messenger-module/emailSettings',
    getTransactions: '/transaction',
  },
  geoJSONCountries: {
    getCountries: 'geo-jsoncountries',
  },
  customerAccountTypes: {
    lookup: '/customerAccountTypes',
  },
  logs: {
    lookup: '/logs',
  },
  notes: {
    lookup: '/notes',
    create: '/notes',
    update: '/notes',
  },
  customerAndUserInvitations: {
    customerInvitations: '/customer-register',
  },
  controlPanel: {
    running: '/control-panel/modules/running',
    installed: '/control-panel/modules/installed',
    start: '/control-panel/start',
    stop: '/control-panel/stop',
    restart: '/control-panel/restart',
    modules: '/control-panel/modules',
    wakeUpUrls: '/control-panel/wakeUpUrls',
    multipleConfig: '/control-panel/multipleConfig',
    getModulesByMachine: '/control-panel/modules/started',
  },
  blackSystem: (param: string) => {
    return {
      export: `black-system/generateAI/${param}/export`,
      start: `black-system/generateAI/${param}/start`,
      number: `black-system/generateAI/${param}/number`,
    };
  },
  // saq: {
  // saqTemplates: {
  // lookup: '/saq-templates',
  // update: '/forms/updateStatus',
  // delete: '/saq-templates',
  // },
  // saqEmailTemplate: {
  //   lookup: '/saq-mail-templates',
  //   create: '/saq-mail-templates',
  //   update: '/saq-mail-templates',
  //   delete: '/saq-mail-templates',
  // },
  // saqSettings: {
  //   lookup: '/saq-settings',
  //   update: '/saq-settings',
  // },
  // },
  // coc: {
  // cocSettings: {
  //   lookup: '/coc-settings',
  //   update: '/coc-settings',
  // },
  // cocEmailTemplate: {
  //   lookup: '/coc-mail-templates',
  //   create: '/coc-mail-templates',
  //   update: '/coc-mail-templates',
  //   delete: '/coc-mail-templates',
  // },
  // cocTemplates: {
  //   lookup: '/coc-templates',
  //   create: '/coc-templates',
  //   update: '/coc-templates',
  //   delete: '/coc-templates',
  //   download: '/coc-templates/download',
  // },
  //   cocInvitations: {
  //     lookup: '/coc-invitations',
  //     create: '/coc-invitations',
  //     verifyCocToken: '/coc-invitations/verifyCocToken',
  //     status: '/coc-invitations/status',
  //     delete: '/coc-invitations',
  //   },
  // },
  configurationChangeRequest: {
    lookup: '/ccr',
    create: '/ccr',
    update: '/ccr',
    destroy: '/ccr',
    download: '/ccr/download',
  },
  troubleTicket: {
    lookup: '/tt',
    create: '/tt',
    update: '/tt',
    destroy: '/tt',
    download: '/tt/download',
  },
  notifications: {
    lookup: '/notifications',
    getNotifications: '/notifications/@me',
    updateStatus: '/notifications/status',
    selectUpdateStatus: '/notifications/multipleStatus',
    allUpdateStatus: '/notifications/changeAllStatus',
    deleteNotification: '/notifications/multipleDelete',
    deleteAllNotification: '/notifications/deleteAll',
    getUnreadNotificationsCount: '/notifications/unreadNotifications',
    getNotificationInfo: '/notifications/notification/@me',
    addLabel: '/notifications/addLabel',
    removeLabel: '/notifications/deleteLabel',
  },
  rules: {
    lookup: '/rules',
    create: '/rules',
    update: '/rules',
    delete: '/rules',
  },
  labels: {
    lookup: '/labels',
    create: '/labels',
    update: '/labels',
    delete: '/labels',
  },
  userRole: {
    lookup: '/user-roles',
    create: '/user-roles',
    update: '/user-roles',
    destroy: '/user-roles',
  },
  userRolePermission: {
    lookup: '/user-role-permissions',
    create: '/user-role-permissions',
    update: '/user-role-permissions',
    destroy: '/user-role-permissions',
  },
  student: {
    lookup: '/students',
    create: '/students',
    update: '/students',
    destroy: '/students',
    exportRecord: '/students/exportPdf',
    exportAll: '',
    reports: {
      download: '/students/reports/dowload',
      lookup: '/students/reports',
      delete: '/students/reports',
      create: '/students/reports',
    },
  },
  counter: {
    dataCount: '/counter/statistic/dashboard',
  },
  sendMail: { mail: '/mailSettings/credentials' },
  forms: {
    form: '/forms',
    send: '/forms/assign',
    duplicate: '/forms/duplicate',
    generateReport: '/forms/generateReport',
    cocReminderEmailUpdate: '/coc-invitations/emailType',
    emailTemplate: '/email-template',
    emailDeliverySetting: '/email-delivery-setting',
  },
  saq: {
    saqInvitation: '/saq-invitation',
    sendSaq: '/saq-invitation/assignSaq',
    saqFormGet: '/saq-invitation/reviewSaq',
    saqSubmitSection: '/saq-invitation/submitForm',
    saqReminderEmailUpdate: '/saq-invitation/saqEmailType',
  },
  coc: {
    cocTemplates: {
      lookup: '/coc-template',
      create: '/coc-template',
      update: '/coc-template',
      delete: '/coc-template',
      download: '/coc-template/download',
    },
    cocInvitations: {
      lookup: '/coc-invitation',
      create: '/coc-invitation',
      verifyCocToken: '/coc-invitation/verifyToken',
      status: '/coc-invitation/status',
      delete: '/coc-invitation',
    },
  },
  resources: {
    lookup: '/resources',
    update: '/resources',
    create: '/resources',
    delete: '/resources',
    download: '/resources/download',
  },
  currencies: {
    lookup: '/currencies',
    table: '/currencies/table',
  },
  states: {
    lookup: '/states',
  },
  transactions: {
    lookup: '/transactions',
  },
  data: {
    blacklistFileUpload: '/black-list',
    exportData: '/report-export/export',
  },
  actions: {
    lookup: '/actions',
    update: '/actions',
    create: '/actions',
    delete: '/actions',
    download: '/actions/download',
  },
  recommendation: {
    lookup: '/recommendation',
    update: '/recommendation',
    create: '/recommendation',
    delete: '/recommendation',
  },
  sections: {
    lookup: '/sections',
    update: '/sections',
    create: '/sections',
    delete: '/sections',
  },
  fileUpload: '/file-upload',
  seeds: '/seeds',
  import: '/imports',
  importStudent: '/imports/student',
  importCurrency: '/imports/currency',
  storage: {
    file: '/storage/file',
    convertDoc: '/storage/convertDoc',
  },
  exports: {
    student: '/exports/student',
    person: '/exports/person',
    vehicle: '/exports/vehicle',
    location: '/exports/location',
    sensor: '/exports/sensor',
    enterprise: '/exports/enterprise',
    topic: '/exports/topic',
    nsearchResult: '/exports/nsearch/result',
    nsearch: '/exports/nsearch',
    relation: '/exports/relation',
    saq: '/exports/saq',
    transaction: '/exports/transaction',
  },
  questions: {
    lookup: '/questions',
    create: '/questions',
    update: '/questions',
    delete: '/questions',
  },
  configSettings: {
    lookup: '/configSettings',
    create: '/configSettings',
  },
};
export const finalUrlsConfig = () => urlsConfig;

export const urlConfigSetter = (result: Record<string, Record<string, string>>) => {
  // urlsConfig.webServerBaseURL = result.webBackend;
  // ? `http://${result.webBackend.host}:${result.webBackend.port}/api`
  // : '';
  urlsConfig.storageServerURL = result.storageServer
    ? `https://${result.storageServer.host}/storage`
    : window.STORAGE_SERVER_URL;

  urlsConfig.loggerServerBaseURL = result.loggerServer
    ? `https://${result.loggerServer.host}/logger`
    : window.LOGGER_SERVER_URL;

  urlsConfig.systemLoginURL = result.systemLoginClient ? `https://${result.systemLoginClient.host}` : '';

  // urlsConfig.systemLoginWebServerBaseURL = result.systemLoginBackend
  //   ? `https://${result.systemLoginBackend.host}/loginApi`
  //   : window.SYSTEM_LOGIN_URL;
  urlsConfig.systemLoginWebServerBaseURL = window.SYSTEM_LOGIN_URL;

  urlsConfig.fileServerBaseURL = result.fileServer ? `https://${result.fileServer.host}` : window.FILE_SERVER_URL;

  urlsConfig.layersServerBaseURL = result.layersServer
    ? `https://${result.layersServer.host}`
    : window.LAYERS_SERVER_URL;

  urlsConfig.cppMessengerURL = result.messenger
    ? `https://${result.messenger.host}/messenger`
    : window.CPP_MESSENGER_URL;

  urlsConfig.surferURL = result.surfer ? `https://${result.surfer.host}/surfer` : window.SURFER_URL;
};

export default urlsConfig;
